import {
  Box,
  Grid,
  GridItem,
  Image,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Divider,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

const NFTView = ({ datas2 }) => {
  const [info, setInfo] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div>
      <Box
        w="100%"
        h={{ base: "600px", md: "500px" }}
        /*   border="1px solid #292929" */
        borderRadius="10px"
        p="15px"
        overflow="auto"
      >
        {datas2?.length > 0 ? (
          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
            templateRows={`repeat(${datas2.length}, 1fr)`} // Set the number of rows dynamically
          >
            {datas2.map((e, i) => {
              if (
                String(e?.interface) === "FungibleAsset" ||
                String(e?.interface) === "FungibleToken"
              ) {
                return null;
              } else if (String(e?.interface) === "V1_NFT") {
                return (
                  <Box
                    _hover={{ cursor: "pointer" }}
                    onClick={() => {
                      setInfo(e);
                      onOpen();
                    }}
                    key={i}
                    w="300px"
                    mr={{ base: "0px", md: "10px" }}
                    mt={{ base: "10px", md: "10px" }}
                    h="350px"
                    borderRadius="15px"
                    p="15px"
                    border="1px solid #292929"
                    overflow="auto"
                  >
                    <Image
                      border="1px solid #292929"
                      src={e?.content?.links?.image}
                      borderRadius="8px"
                      w="100%"
                      h="80%"
                      fallbackSrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSP0eSnQyTzpoQwl2gYy6F-G-Nhu6MXxOps8R6IGbKcmQ&s"
                    />
                    <Box mt="10px" fontSize="12px" color="gray.500">
                      {e?.content?.metadata?.symbol}
                    </Box>
                    <Box fontSize="16px">{e?.content?.metadata?.name}</Box>
                    {/*  <Box fontSize="12px">
                {e?.content?.metadata?.attributes?.map((attr, index) => (
                  <Box
                    key={index}
                    w="150px"
                    h="50px"
                    borderRadius="10px"
                    border="1px solid red"
                  >
                    <Box>Hi</Box>
                    <Flex flexDir="column" alignItems="flex-start">
                      <Box>{attr?.trait_type}</Box>
                      <Box>{attr?.value}</Box>
                    </Flex>
                  </Box>
                ))}
              </Box> */}
                  </Box>
                );
              }
            })}
          </Grid>
        ) : (
          <Flex
            justify="center"
            align="center"
            w="100%"
            h="100%"
            fontSize="14px"
          >
            No NFTs found
          </Flex>
        )}
      </Box>

      <Modal
        size={{ base: "full", md: "2xl" }}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent bg={{ base: "black", md: "#15161a" }}>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Image
              maxW={{ base: "300px", md: "400px" }}
              minH="200px"
              border="1px solid #292929"
              src={info?.content?.links?.image}
              borderRadius="8px"
            />
            <Box mt="10px" fontSize="16px" color="gray.500">
              {info?.content?.metadata?.symbol}
            </Box>
            <Box fontSize="30px">{info?.content?.metadata?.name}</Box>
            <Box>
              {info?.content?.metadata?.attributes?.length > 0 ? (
                <Box fontSize="20px" mt="30px">
                  Attributes{" "}
                </Box>
              ) : (
                ""
              )}
              <Grid
                mt="20px"
                templateColumns={`repeat(auto-fill, minmax(150px, 1fr))`} // Dynamic columns based on content width
                gap={4} // Gap between grid items
              >
                {info?.content?.metadata?.attributes?.map((attr, index) => (
                  <Box
                    key={index}
                    w="100%"
                    borderRadius="10px"
                    border="1px solid #222226"
                    p={2} // Padding for grid items
                  >
                    <Flex flexDir="column" alignItems="flex-start">
                      <Box fontSize="11px" color="gray.500" fontWeight="500">
                        {attr?.trait_type}
                      </Box>
                      <Box fontSize="14px">{attr?.value}</Box>
                    </Flex>
                  </Box>
                ))}
              </Grid>
            </Box>

            <Divider mt="20px" mb="10px" />

            <Box fontSize="20px">Description</Box>
            <Box fontSize="14px" mt="10px">
              {info?.content?.metadata?.description}
            </Box>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default NFTView;
